// src/Md.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var Md_default = createIcon({
  displayName: "Md",
  viewBox: "0 0 48 32",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { id: "red", x: "32", width: "16", height: "32", fill: "#E94B35" }),
    /* @__PURE__ */ jsx("rect", { id: "blue", width: "16", height: "32", fill: "#227FBB" }),
    /* @__PURE__ */ jsx("rect", { id: "yellow", x: "16", width: "16", height: "32", fill: "#F2C500" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 11L22 12L20 11L19.6205 10.241C19.5724 10.1448 19.5092 10.0571 19.4332 9.98106C19.0426 9.59053 18.4095 9.59053 18.0189 9.98106L17 11V23L23 19L20 24L24 26L28 24L25 19L31 23V11L29.9811 9.98106C29.9051 9.90506 29.8173 9.84181 29.7212 9.79374C29.2272 9.54675 28.6265 9.74697 28.3795 10.241L28 11L26 12L25 11V9.61805C25.3069 9.34339 25.5 8.94425 25.5 8.5C25.5 7.67157 24.8284 7 24 7C23.1716 7 22.5 7.67157 22.5 8.5C22.5 8.94425 22.6931 9.34339 23 9.61805V11Z",
        fill: "#AF7D61"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Rectangle 41",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12H28V19L24 21L20 19V12Z",
        fill: "#2C97DE"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Rectangle 41_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 12H28V16H20V12Z",
        fill: "#E94B35"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Rectangle 40",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M23 16H25V19L24 20L23 19V16Z",
        fill: "#F2C500"
      }
    ),
    /* @__PURE__ */ jsx("circle", { id: "Oval 42", cx: "24", cy: "14", r: "1", fill: "#F2C500" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Combined Shape_2",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M26.45 14C26.2184 15.1411 25.2095 16 24 16C22.7905 16 21.7816 15.1411 21.55 14C21.5172 14.1616 21.5 14.3288 21.5 14.5C21.5 15.8807 22.6193 17 24 17C25.3807 17 26.5 15.8807 26.5 14.5C26.5 14.3288 26.4828 14.1616 26.45 14Z",
        fill: "#F2C500"
      }
    )
  ] })
});

export {
  Md_default
};
